// import inspectionList from '../components/inspection/inspectionList.vue'
// import viewInspections from '../components/inspection/viewInspections.vue'
// import analysisList from '../components/inspection/analysisList.vue'
// import patrolList from '../components/inspection/patrolList.vue'
// import qyPatrol from '../components/inspection/qyPatrol.vue'
// import viewPatrol from '../components/inspection/viewPatrol.vue'
// import addExamine from '../components/inspection/addExamine.vue'
// import examineList from '../components/inspection/examineList.vue'
// import examineWhList from '../components/inspection/examineWhList.vue'
// import mainPointsList from '../components/inspection/mainPointsList.vue'
// import viewAnalysis from '../components/inspection/viewAnalysis.vue'

export default [
    {
        path: 'inspection/inspectionList',
        component: resolve => require(['@/components/inspection/inspectionList'],resolve),
        name:"InspectionList",
        meta:{
            id:'754',
            node:'inspection',
            url:'inspectionList',
        }
    },
    {
        path: 'inspection/viewInspections',
        component: resolve => require(['@/components/inspection/viewInspections'],resolve),
        name:"ViewInspections",
        meta:{
            id:'755',
            node:'inspection',
            url:'viewInspections',
        }
    },
    {
        path: 'inspection/analysisList',
        component: resolve => require(['@/components/inspection/analysisList'],resolve),
        name:"AnalysisList",
        meta:{
            id:'794',
            node:'inspection',
            url:'analysisList',
        }
    },
    {
        path: 'inspection/patrolList',
        component: resolve => require(['@/components/inspection/patrolList'],resolve),
        name:"PatrolList",
        meta:{
            id:'791',
            node:'inspection',
            url:'patrolList',
        }
    },
    {
        path: 'inspection/qyPatrol',
        component: resolve => require(['@/components/inspection/qyPatrol'],resolve),
        name:"QyPatrol",
        meta:{
            id:'788',
            node:'inspection',
            url:'qyPatrol',
        }
    },
    {
        path: 'inspection/viewPatrol',
        component: resolve => require(['@/components/inspection/viewPatrol'],resolve),
        name:"ViewPatrol",
        meta:{
            id:'792',
            node:'inspection',
            url:'viewPatrol',
        }
    },
    {
        path: 'inspection/addExamine',
        component: resolve => require(['@/components/inspection/addExamine'],resolve),
        name:"AddExamine",
        meta:{
            // id:'788',
            node:'inspection',
            url:'addExamine',
        }
    },
    {
        path: 'inspection/examineList',
        component: resolve => require(['@/components/inspection/examineList'],resolve),
        name:"ExamineList",
        meta:{
            // id:'792',
            node:'inspection',
            url:'examineList',
        }
    },
    {
        path: 'inspection/examineWhList',
        component: resolve => require(['@/components/inspection/examineWhList'],resolve),
        name:"ExamineWhList",
        meta:{
            id:'806',
            node:'inspection',
            url:'examineWhList',
        }
    },
    {
        path: 'inspection/mainPointsList',
        component: resolve => require(['@/components/inspection/mainPointsList'],resolve),
        name:"MainPointsList",
        meta:{
            id:'805',
            node:'inspection',
            url:'mainPointsList',
        }
    },
    {
        path: 'inspection/viewAnalysis',
        component: resolve => require(['@/components/inspection/viewAnalysis'],resolve),
        name:"ViewAnalysis",
        meta:{
            // id:'792',
            node:'inspection',
            url:'viewAnalysis',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/inspection.js